<script>
  import { Moon } from 'svelte-loading-spinners';
  import Error from './form/Error.svelte';
  import SqlEditor from './form/SqlEdior/editor.svelte';
  import classNames from '../utils/classNames';
  import { createEventDispatcher } from 'svelte';
  import { checkQuery } from '../api';

  const dispatch = createEventDispatcher();

  export let id = 'sqleditor';
  export let query = '';
  export let params = [];
  // values sent to api
  export let filter = {};

  let querySyntaxError;
  let querySyntaxErrorMessage = '';

  let testQueryLoading = false;
  let testQueryPass = false;
  let testQueryError;

  function validateQuerySyntax(query) {
    //set interactive message based on regex validation
    if (!/select\s+(.*?)/gi.test(query)) {
      //check for select keyword
      return {
        querySyntaxError: true,
        querySyntaxErrorMessage: 'Syntax Error, Syntax should begin with select.',
      };
    } else if (!/\s*from\s+(.*?)/gi.test(query)) {
      testQueryPass = false;
      //check for from keyword
      return {
        querySyntaxError: true,
        querySyntaxErrorMessage: "Syntax Error, Syntax should contain 'from'.",
      };
    } else if (!/\s*((.*?)\s*)?;/gi.test(query)) {
      testQueryPass = false;
      //check closing tag ;  keyword which is required
      return {
        querySyntaxError: true,
        querySyntaxErrorMessage: 'Syntax Error, Please end the statement with ;',
      };
    } else if (!/select\s+(.*?)\s*from\s+(.*?)\s*(where\s(.*?)\s*)?;/gi.test(query)) {
      testQueryPass = false;
      return {
        querySyntaxError: true,
        querySyntaxErrorMessage: 'Syntax Error, Please check your query.',
      };
    } else {
      return { querySyntaxError: false, querySyntaxErrorMessage: '' };
    }
  }

  function onReportQueryChange(event) {
    query = event.detail;

    if (query) {
      query = query;
      let getError = validateQuerySyntax(query);
      querySyntaxError = getError?.querySyntaxError;
      querySyntaxErrorMessage = getError?.querySyntaxErrorMessage;

      dispatch('change', { value: query, error: querySyntaxErrorMessage });
    }
  }

  async function testValidateQuery() {
    testQueryLoading = true;
    // const _filters = paramsToFilters(params);
    // filters = _filters;
    const p = params?.filter((p) => !!p.name);

    let newData = {
      filter,
      query,
      params: JSON.stringify(p),
      query_type: 'summary_query',
    };
    try {
      const response = await checkQuery(newData);
      console.log(response);

      testQueryError = false;
      testQueryPass = true;
    } catch (error) {
      testQueryError = true;
      testQueryPass = false;
    } finally {
      testQueryLoading = false;
    }
  }
</script>

<!-- Totals -->
<div class="flex flex-col items-center mt-16">
  <SqlEditor
    label="Query Total Builder"
    on:querying={onReportQueryChange}
    name="summary_query"
    {id}
    {query}
    {params}
  />
  <Error fieldName="query" errorKey="minLength" />
</div>
<button
  type="button"
  on:click={testValidateQuery}
  disabled={testQueryLoading || querySyntaxError}
  class={classNames(
    `w-48 h-8 relative inline-flex items-center justify-center float-right ml-2 text-white
     text-sm font-bold rounded px-2 py-1 gap-2`,
    testQueryLoading ? 'bg-custom-gray' : 'bg-custom-query-button'
  )}
>
  {#if testQueryLoading}
    <Moon size="1" color="#F78907" unit="rem" duration="1s" />
  {/if}
  <div>{testQueryLoading ? ` Loading...` : 'Test Query'}</div>
</button>
{#if query && querySyntaxError}
  <p class="text-red-500 text-xs">
    {querySyntaxErrorMessage}
  </p>
{/if}
{#if query && testQueryError}
  <p class="text-red-500 text-xs">The query wasn't successfully completed.</p>
{/if}
{#if testQueryPass && !querySyntaxError}
  <p class="text-green-500 text-xs">The query was successfully completed</p>
{/if}
